import React, { Component } from "react";

class VideoOverlay extends Component {
  state = {
    showVideo: false,
  };

  videoRef = React.createRef();

  toggleVideo = () => {
    if (this.state.showVideo && this.videoRef.current) {
      this.videoRef.current.pause();
    }
    this.setState({ showVideo: !this.state.showVideo });
  };

  handleVideoEnd = () => {
    this.setState({ showVideo: false });
  };

  handleVideoClick = (e) => {
    e.stopPropagation(); 
    const video = this.videoRef.current;
    if (video) {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
      this.forceUpdate();
    }
  };

  render() {
    const { showVideo } = this.state;
    const imageUrl = process.env.REACT_APP_S3URL + this.props.image_url;
    const videoUrl = this.props.video_url ? process.env.REACT_APP_S3URL + this.props.video_url : null;

    return (
      <div className="video-container position-relative">
        <div className="doc-img border-radius overflow-hidden">
          <img src={imageUrl} alt="Doctor" className="img-fluid" />
          {videoUrl && (<img
            src="/profile/play (1).svg"
            alt="Play"
            onClick={this.toggleVideo}
            className="play-icon"
          />
          )}
        </div>

        {showVideo && (
          <div className="video-overlay">
            <div className="video-content" >
              <img
                src="/close (1).svg"
                alt="Close"
                className="close-icon"
                onClick={this.toggleVideo}
              />
              <video
                ref={this.videoRef}
                controls
                autoPlay
                controlsList="nodownload"
                onEnded={this.handleVideoEnd}
                onClick={this.handleVideoClick}
              >
                <source src={videoUrl} type="video/mp4" />
              </video>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default VideoOverlay;
